// Importa los estilos
import useStyles from './styles';
import { Button, IconButton } from '@mui/material';
import AxLogo from 'src/assets/logo_axeleratum.png';
import { Facebook, LinkedIn, Instagram } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import politicas_seguridad from './politicas_seguridad.pdf';
import aviso_privacidad from './aviso_privacidad.pdf';
import terminos_orkestadoc from './terminos_orkestadoc.pdf';

const Footer = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  // Función para manejar la redirección a redes sociales
  const handleSocialClick = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <footer className={classes.footer}>
      <div className={classes.content}>
        <img src={AxLogo} alt="Klaus Logo" />
        <div className={classes.logoDiv}>
          <div className={classes.socialIcons}>
            <IconButton onClick={() => handleSocialClick('https://www.linkedin.com/company/axeleratum1/')} aria-label="LinkedIn">
              <LinkedIn sx={{ color: 'white' }} />
            </IconButton>
          </div>
        </div>
      </div>
      <hr className={classes.divider} />
      <div className={classes.bottomText}>
        <span className={classes.leftText}>{`${t('COPYRIGHT')}`}</span>
        <span className={classes.rightText} onClick={() => window.open(terminos_orkestadoc, '_blank', 'noopener,noreferrer')}>{`${t('TERMS_CONDITIONS')}`}</span>
        <span className={classes.rightText} onClick={() => window.open(politicas_seguridad, '_blank', 'noopener,noreferrer')}>{`${t('POLICIES_SECURITY')}`}</span>
        <span className={classes.rightText} onClick={() => window.open(aviso_privacidad, '_blank', 'noopener,noreferrer')}>{`${t('PRIVACY')}`}</span>
      </div>
    </footer>
  );
};

export default Footer;
